import app from 'flarum/forum/app';
import Model, {SavedModelData} from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
import ItemList from 'flarum/common/utils/ItemList';
import Badge from 'flarum/common/components/Badge';
import Picture from './Picture';

export default class Album extends Model {
    title = Model.attribute<string>('title')
    slug = Model.attribute<string>('slug')
    description = Model.attribute<string>('description')
    isCommunity = Model.attribute<boolean>('isCommunity')
    isHidden = Model.attribute<boolean>('isHidden')
    hiddenAt = Model.attribute('hiddenAt', Model.transformDate)

    canUpload = Model.attribute<boolean>('canUpload')
    canEdit = Model.attribute<boolean>('canEdit')
    canHide = Model.attribute<boolean>('canHide')
    canRestore = Model.attribute<boolean>('canRestore')
    canDelete = Model.attribute<boolean>('canDelete')

    user = Model.hasOne<User>('user')
    coverPicture = Model.hasOne<Picture>('coverPicture')
    picturesFirstPage = Model.hasMany<Picture>('picturesFirstPage')
    discussions = Model.hasMany<Discussion>('discussions')

    badges() {
        const items = new ItemList();

        if (this.isHidden()) {
            items.add('hidden', Badge.component({
                type: 'hidden',
                icon: 'fas fa-trash',
                label: app.translator.trans('kilowhat-cimaise.forum.badge.hidden'),
            }));
        }

        return items;
    }

    apiEndpoint() {
        return '/cimaise/albums' + (this.exists ? '/' + (this.data as SavedModelData).id : '');
    }
}
